import styles from './index.module.scss';

export const Loading = () => {
    return (
        <div className={styles.loadingMask}>
            <div className={styles.loadingSpinner}></div>
        </div>
    );
};
